<template>
    <div class="calendar">
        <div class="header">
            <button @click="previousMonth">&lt;</button>
            <h2>{{ currentMonth }}</h2>
            <button @click="nextMonth">&gt;</button>
        </div>
        <div class="days">
            <div v-for="day in daysInMonth" :key="day" class="day">
                <div>{{ day }}</div>
                <div class="events" @click="showEventList(day)">
                    <div v-for="(eventData, index) in getEventsForDay(day)" :key="index" class="event">
                     <img style="width:6px" src="../assets/img/round.png" />   <strong>{{ eventData.length }} event(s)</strong>
                    </div>
                </div>
            </div>
        </div>
        <CRow class="event-list">
      <CCol sm="4" v-for="event in selectedDayEvents" :key="event.ID">
        <ul>
          <li>
            <CCard>
              <CCardBody>
                <img style="max-width:100%" src="../assets/img/photo1.png" />
                <CRow>

                
                <CCol sm="6">
                                                        <div class="custom-label-tag-blue-light mt-2">
                                                            {{  event.start | moment("MM DD YYYY") }}
                                                        </div>
                                                    </CCol>
                                                    <CCol sm="6">
                                                        <div class="mt-2">
                                                            <img style="width:20px" src="../assets/img/user.png" />  Registered
                                                        </div>
                                                    </CCol>
                <strong></strong>

                <CCol sm="12">
                                                        <h3 class="custom-14px-500 text-left mt-3">
                                                            <b>
                                                                       {{  event.title }}
                                                                    </b>
                                                        </h3>
                                                    </CCol>
            </CRow>
              </CCardBody>
            </CCard>
          </li>
        </ul>
      </CCol>
    </CRow>
    
    </div>
</template>
  
<script>
import moment from "moment";
Vue.use(require("vue-moment"));

import Vue from "vue";
export default {
    data() {
        return {
            currentDate: new Date(),
            events: [],
            selectedDay: null,
            clickedDay: null,
            selectedDayEvents: []
        };
    },
    computed: {
        currentMonth() {
            return this.currentDate.toLocaleString('default', { month: 'long', year: 'numeric' });
        },
        daysInMonth() {
            const days = [];
            const lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDate();
            for (let i = 1; i <= lastDay; i++) {
                days.push(i);
            }
            return days;
        }
    },
    methods: {
        previousMonth() {
        const newDate = new Date(this.currentDate);
        newDate.setMonth(newDate.getMonth() - 1);
        this.currentDate = newDate;
        this.fetchEvents();
    },
    nextMonth() {
        const newDate = new Date(this.currentDate);
        newDate.setMonth(newDate.getMonth() + 1);
        this.currentDate = newDate;
        this.fetchEvents();
    },
       fetchEvents() {
    const url = 'https://www.pickiddo.com/PICKIDDO_BE/api/kiddo/read/GetScheduleTc';
    fetch(url)
        .then(response => response.json())
        .then(data => {
            this.events = data;
            // After updating events, update selectedDayEvents based on the selected day
            if (this.selectedDay) {
                this.selectedDayEvents = this.getEventsForDay(this.selectedDay)[0];
            }
        })
        .catch(error => {
            console.error('Error fetching events:', error);
        });
},
        getEventsForDay(day) {
            // Filter events for the given day
            const events = this.events.filter(event => {
                const eventDate = new Date(event.Start).getDate();
                return eventDate === day;
            });
            return [events];
        },
        showEventList(day) {
            if (this.selectedDay === day) {
                this.selectedDay = null;
                this.selectedDayEvents = [];
            } else {
                this.selectedDay = day;
                this.clickedDay = day;
                this.selectedDayEvents = this.getEventsForDay(day)[0];
            }
        }
    },
    mounted() {
        this.fetchEvents();
    }
};
</script>
  
<style scoped>
.calendar {
    font-family: Arial, sans-serif;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
}

.day {
    padding: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    /* Add cursor pointer for interaction */
}

.events {
    margin-top: 5px;
}

.event {
    padding: 5px;
    margin-top: 2px;
}

.event-list {
    margin-top: 20px;
}

.event-list ul {
    list-style: none;
    padding: 0;
}

.event-list li {
    margin-bottom: 5px;
}
</style>
  